import React, { Component } from 'react'

export class PhoneSvg2 extends Component {
    render() {
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={this.props.width}
                height={this.props.height}
                fill="none"
                viewBox="0 0 24 24"
            >
                <path
                    fill={this.props.fill}
                    d="M9 2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V2Z"
                />
                <rect
                    width={12.5}
                    height={20.5}
                    x={5.75}
                    y={1.75}
                    stroke={this.props.fill}
                    strokeWidth={1.5}
                    rx={1.75}
                />
                <path stroke={this.props.fill} strokeLinecap="round" strokeWidth={1.5} d="M9 19.5h6" />
            </svg>
        )
    }
}

export default PhoneSvg2